export default __webpack_public_path__ + "images/e74aa8f45f3d9b3da85e5ad82be8ff8a.png";